
<template>
  <div>
    <form id="simulRaccoModalOptions" method='GET' enctype='multipart/form-data' :action=routesubmit>
      <div class="row my-auto mx-0">
        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
          <h5 class="colorText"> {{ trans.get("common.simulracco.call_api") }}:</h5> 
        </div>
        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
          <p>
            <a @click="afficheModal">
              <span class="buttonOriginal glyphicon glyphicon-search"></span>
            </a>
          </p>
        </div>
      </div>
      <div class="col-md-6 col-md-offset-2" >
        <simulRaccoModalContent v-if="showModal" @close="closeModal"></simulRaccoModalContent>
      </div>
    </form>
  </div>
</template>

<script>

import simulRaccoModalContent from './simulRaccoModalContent.vue'

export default {
  name:'simulraccobuttonmodal',
  components: {
    simulRaccoModalContent
  },
  props: ["routesubmit"],
  data() {
    return {
      showModal: false,
    }
  },
  mounted(){
  },
  methods: {
    afficheModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>
